// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_2B6cI","hidden":"_22iFU","fullScreenControl":"_3pNnE","fullScreenToggle":"_1a5nR","enterIcon":"_3gfA7","exitIcon":"_222r4","inFullScreen":"_16bOq"};